import React from 'react'
import Download from '../../Components/Download/Download'
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./vendorforgot.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from "../../BASE_URL";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Vendorforgot = () => {
    const [dell, setDell] = useState({
        contact_no: "",
        password: "",
    });
    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);

    const [notifications, setNotifications] = useState([]);


    const txt = (e) => {
        const { name, value } = e.target;
        setDell({ ...dell, [name]: value });
    };

    const handleSubmit = async () => {
        handleLogin();
    };

    const handleLogin = async () => {
        const { contact_no, password } = dell;
        const formattedContactNo = "+91" + contact_no;

        if (!contact_no && !password) {
            toast.error('Please Enter Your Registered Mobile Number & Password!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
            return;
        }

        if (!contact_no) {
            toast.error('Please Enter Register Mobile Number!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
            return;
        }

        if (formattedContactNo.length !== 13) {
            toast.error('Please Enter 10 Digit Contact No!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
            return;
        }


        if (!password) {
            toast.error('Please Enter Your Password!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
            return;
        }


        const res = await fetch(`${BASE_URL}/api/profile/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                contact_no: formattedContactNo,
                password,
            }),
        });

        const abc = await res.json();

        if (abc.code === 200) {
            navigate("/profile");
            localStorage.setItem("user", JSON.stringify(abc.data));
            localStorage.setItem("token", abc.data.token);
            localStorage.setItem("preference-detail", "preference");
            localStorage.setItem("family-detail", "family");
            localStorage.setItem("fillup", "fill the data");
            localStorage.setItem("contact_no", formattedContactNo);
            localStorage.setItem("firebase_id", abc.data.Fields.firebase_id);
            const currentDateAndTime = new Date().toLocaleDateString();
            localStorage.setItem("loginDateTime", currentDateAndTime);
        } else {
            toast.error('Please Enter Registered Mobile Number and Password!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
        }
    };


    useEffect(() => {
        const storedToken = localStorage.getItem("saptvidhiUserToken");
        if (storedToken) {
            navigate("/profile");
        }
    }, [navigate]);
    return (
        <>
            <div className='d-flex justify-content-center'>
                <div className="vendor_forgot__wrapepr">
                    <div className='back-left-arrow' style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <h2 className='text-center fw-semibold'>Forgot Password</h2>
                    <div className="vendor_login">
                        <div className='d-flex justify-content-center my-5'>
                            <input
                                placeholder="Enter Mobile Number"
                                type="tel"
                                onInput={(e) => (e.target.value) = e.target.value.replace(/[^0-9]/g, '')}
                                maxLength="10"
                                onChange={txt}
                                name="contact_no"
                                style={{ width: "70%" }}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        handleLogin();
                                    }
                                }}
                            />
                        </div>
                        <div id="recaptcha"></div>
                        <ToastContainer />
                        <div className='d-flex vendor-login-btn flex-column'>
                            <button onClick={() => navigate('/vendor-otp-verification')}>Continue</button>
                        </div>
                    </div>
                </div>
            </div>
            <Download />
        </>
    )
}

export default Vendorforgot
